import { ColorModel, MaterialModel } from '@common/models';
import { RootState } from '@redux/store';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface MaterialAndColor {
    material?: MaterialModel;
    color: ColorModel;
}

interface MaterialState {
    restorableMaterial?: Partial<MaterialModel>;
    selectedMaterial?: MaterialModel;
    prevSelectedMaterial?: MaterialModel;
    requestedColor?: MaterialAndColor;
}

const initialState: MaterialState = {
    restorableMaterial: undefined,
    selectedMaterial: undefined,
    prevSelectedMaterial: undefined,
    requestedColor: undefined,
};

const materialSlice = createSlice({
    name: 'material',
    initialState,
    reducers: {
        updateRestorableMaterial: (state, action: PayloadAction<Partial<MaterialModel> | undefined>) => {
            state.restorableMaterial = action.payload;
        },
        updateSelectedMaterial: (state, action: PayloadAction<MaterialModel | undefined>) => {
            state.selectedMaterial = action.payload;
        },
        updatePrevSelectedMaterial: (state, action: PayloadAction<MaterialModel | undefined>) => {
            state.prevSelectedMaterial = action.payload;
        },
        resetSelectedMaterial: (state) => {
            state.selectedMaterial = undefined;
        },
        /**
         * Use this to set both new material and color in one atomic action
         * @param state
         * @param action
         */
        updateRequestedColor: (state, action: PayloadAction<MaterialAndColor | undefined>) => {
            state.requestedColor = action.payload;
        },
        resetRequestedColor: (state) => {
            state.requestedColor = undefined;
        },
    },
});

export const {
    updateRestorableMaterial,
    updateSelectedMaterial,
    updatePrevSelectedMaterial,
    resetSelectedMaterial,
    updateRequestedColor,
    resetRequestedColor,
} = materialSlice.actions;

export default materialSlice.reducer;

export const selectRestorableMaterial = ({ material }: RootState): Partial<MaterialModel> | undefined => {
    return material.restorableMaterial;
};

export const selectSelectedMaterial = ({ material }: RootState): MaterialModel | undefined => material.selectedMaterial;
export const selectPrevSelectedMaterial = ({ material }: RootState): MaterialModel | undefined =>
    material.prevSelectedMaterial;
export const selectRequestedColor = ({ material }: RootState): MaterialAndColor | undefined => material.requestedColor;
